import { MinzeElement, Attrs } from 'minze'

export interface LvcRandomCharlie {
  maxWidth: string
  maxHeigh: string
}

export class LvcRandomCharlie extends MinzeElement {
  attrs: Attrs = [
    ['maxWidth', '240px'],
    ['maxHeigh', '240px'],
  ]
  static observedAttributes = ['maxWidth', 'maxHeigh']
  maxIndex: number = 5
  randomIndex: number = Math.floor(Math.random() * this.maxIndex)

  html = () => {
    switch (this.randomIndex) {
      case 0:
        return `<lvc-charlie-icon width="100%" height="auto"></lvc-charlie-icon>`
      case 1:
        return `<lvc-charlie-ecoute-icon width="100%" height="auto"></lvc-charlie-ecoute-icon>`
      case 2:
        return `<lvc-charlie-hands-together width="100%" height="auto"></lvc-charlie-hands-together>`
      case 3:
        return `<lvc-charlie-peacesign-icon width="100%" height="auto"></lvc-charlie-peacesign-icon>`
      case 4:
        return `<lvc-charlie-waving-icon width="100%" height="auto"></lvc-charlie-waving-icon>`
      default:
        return `<lvc-charlie-icon width="100%" height="auto"></lvc-charlie-icon>`
    }
  }

  css = () => `
    :host {
      max-width: ${this.maxWidth};
      max-height: ${this.height};
    }
  `
}
